<template>
  <div class="w-full">

    <TheNavigation />

    <Header v-if="$route.path == '/'" />
    <HeaderSecondary v-else />
    <!-- <ActiveTestings /> -->


    <!--
      Этот key нужен, чтобы убрать глюк, когда в пути меняется только парамтер, 
      и путь в адресной строке меняется, а страница не перезагружается.
      см. fooobar . com/questions/15987837/vue-router-not-firing-if-only-slug-changes
    -->
    <!-- w-4/5 mx-auto -->
    <div class="">
      <router-view :key="$route.fullPath" />
    </div>

    <TheFooter />
  </div>
</template>

<script>
global.jQuery = require("jquery");
var $ = global.jQuery;
var jQuery = global.jQuery;
window.$ = $;
window.jQuery = jQuery;

//var funcNames = ["log", "warn", "error", "info"];
//var colors = ['color:green', 'color:orange', 'color:red', 'background-color:green'];
/*
  если нигде не аукнется, то грохнуть!!!
var funcNames = ["info"];
var colors = ['background-color:green'];
for (var i = 0; i < funcNames.length; i++) {
    let funcName = funcNames[i];
    let color = colors[i];
    let oldFunc = console[funcName];
    console[funcName] = function () {
        var args = Array.prototype.slice.call(arguments);
        if (args.length) args = ['%c' + args[0]].concat(color, args.slice(1));
        oldFunc.apply(null, args);
    };
}
*/

import TheNavigation from "@/components/TheNavigation";
// import ActiveTestings from "@/components/ActiveTestings";
import Header from "@/components/Header";
// import HeaderSecondary from "@/components/HeaderSecondary.vue";
import HeaderSecondary from "@/components/Header.vue";
import TheFooter from "@/components/Footer2";

export default {
  components: {
    TheNavigation,
    Header,
    HeaderSecondary,
    TheFooter,
    // ActiveTestings,
  },
};
</script>




